<template>
  <div class="progress-container">
    <div class="progress-bar" ref="progressBar" @click="onBarClick">
      <div class="progress-fill" :style="{ width: progress + '%' }"></div>

      <!-- 刻度 -->
      <div
          v-for="mark in marks"
          :key="mark.value"
          class="progress-mark"
          :style="{ left: mark.value + '%' }"
          :class="{ active: progress >= mark.value }"
      ></div>

      <!-- 拖拽按钮 -->
      <div
          class="progress-handle"
          :style="{ left: progress + '%' }"
          @mousedown="startDrag"
          @touchstart="startDrag"
      >
        <div class="progress-tooltip">{{ progress }}{{units}}</div>
      </div>
    </div>
    <div style="margin-top: 17px;width: 104%;margin-left: 0%;display: flex;justify-content: space-between">
      <div class="left-mark" v-for="(item,index) in content" :key="index">{{item}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DraggableProgress',
  props: {
    units:{
      type:String,
      default: "%"
    },
    content:{
      type:Array,
      default:["0","100%"]
    },

    value: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      progress: this.value,
      marks: [
        { value: 0 },
        { value: 25 },
        { value: 50 },
        { value: 75 },
        { value: 100 }
      ],
      isDragging: false
    };
  },
  watch: {
    value(newVal) {
      console.log("value is new",newVal);
      newVal=Math.min(100,newVal);
      this.progress = newVal;
    },
    progress(newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    startDrag(e) {
      e.preventDefault();
      this.isDragging = true;

      // 为鼠标和触摸事件添加监听
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('touchmove', this.onDrag);
      window.addEventListener('mouseup', this.stopDrag);
      window.addEventListener('touchend', this.stopDrag);
    },
    onDrag(e) {
      if (!this.isDragging) return;

      const progressBar = this.$refs.progressBar;
      const rect = progressBar.getBoundingClientRect();
      let clientX;

      if (e.type.includes('touch')) {
        clientX = e.touches[0].clientX;
      } else {
        clientX = e.clientX;
      }

      let percentage = (clientX - rect.left) / rect.width;
      percentage = Math.max(0, Math.min(1, percentage)); // 限制在0-1之间
      this.progress = Math.round(percentage * 100);
      console.log("progress is",this.progress);
    },
    stopDrag() {
      this.isDragging = false;

      // 移除事件监听
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('touchmove', this.onDrag);
      window.removeEventListener('mouseup', this.stopDrag);
      window.removeEventListener('touchend', this.stopDrag);
    },
    onBarClick(e) {
      const progressBar = this.$refs.progressBar;
      const rect = progressBar.getBoundingClientRect();
      const percentage = (e.clientX - rect.left) / rect.width;
      this.progress = Math.round(percentage * 100);
    }
  }
};
</script>

<style scoped>
.progress-container {
  height: 10px;
  margin-top: 32px;
  /*padding: 20px 0;*/
  width: calc(100% - 24px);
  margin-left: 9px;
  margin-bottom: 24px;
}

.progress-bar {
  position: relative;
  height: 2px;
  background-color: #26282B;
  border-radius: 4px;
  cursor: pointer;
}

.progress-fill {
  height: 100%;
  background-color: #C6FE61;
  border-radius: 4px;
  transition: width 0.1s ease;
}

.progress-mark {
  position: absolute;
  width: 9px;
  height: 9px;
  background-color: rgba(24, 26, 32, 1);
  border: 2px solid #26282B;
  transform: translate(-50%, -25%) rotate(45deg);
  top: 50%;
  z-index: 2;
  border-radius: 2px;
  margin-top: -3px;
}

.progress-mark.active {
  background-color: #C6FE61;
  border-color: #999;
}

.progress-handle {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #000;
  border: 3px solid #C6FE61;
  border-radius: 3px;
  transform: translate(-50%, -50%) rotate(45deg);
  top: 50%;
  z-index: 3;
  cursor: grab;
}

.progress-handle:active {
  cursor: grabbing;
}

.progress-tooltip {
  position: absolute;
  bottom: 100%;
  /*left: 50%;*/
  transform: translateX(-50%) rotate(-45deg);
  /*background-color: #000;*/
  color: #C6FE61;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  margin-left: -10px;
  /*margin-bottom: 10px;*/
}
.left-mark{
  float: left;font-size: 14px;color:#E5E5E5
}
.right-mark{
  float: right;font-size: 14px;color:#E5E5E5
}

/* 防止旋转后文字被裁剪 */
/*.progress-tooltip::before {*/
/*  content: '';*/
/*  position: absolute;*/
/*  top: 100%;*/
/*  left: 50%;*/
/*  transform: translateX(-50%);*/
/*  width: 0;*/
/*  height: 0;*/
/*  border-left: 5px solid transparent;*/
/*  border-right: 5px solid transparent;*/
/*  border-top: 5px solid #000;*/
/*}*/
@media (max-width: 750px) {
  .progress-mark{
    width: 7px!important;
    height: 7px!important;
  }
  .progress-handle{
    width: 10px;
    height: 10px;
  }
  .progress-bar{
    height: 2px;
  }
  .left-mark{
    font-size: 12px;
  }
  .right-mark{
    font-size: 12px;
  }
  .progress-mark{
    background: #000;
  }
}
</style>
